<template>
  <pp-app>
    <contact-us />
  </pp-app>
</template>

<script>
import ContactUs from '@/views/ContactUs'
import { reportLoadedSuccessfully } from 'sdk-widget-manager'

const CONTACT_US_ENTITLEMENT = 'websites.widgets.contact-us-v1'

export default {
  name: 'App',
  components: {
    'contact-us': ContactUs
  },
  mounted () {
    try {
      reportLoadedSuccessfully(CONTACT_US_ENTITLEMENT)
    } catch (_) {
      this.$ppAnalytics.trackEvent({
        action: 'contact_us_widget_wm_load_error'
      })
    }
  }
}
</script>

<style lang="scss">
body {
  background-color: $white;
}
</style>
